import { useCallback } from 'react';
import { ActivityType } from '../../types/CustomRoute';
import { useDispatch, useSelector } from '../../redux';
import { updateRouting } from '../../redux/customRoute';
import { isSegmentRoutable } from '../../utils/customRoutes/validation';
import useRerouteSegments from './useRerouteSegments';

const useOnActivityChange = () => {
  const dispatch = useDispatch();
  const segments = useSelector(state => state.customRoute.route.segments);
  const rerouteSegments = useRerouteSegments();

  const onActivityChange = useCallback(
    async (newActivity: ActivityType) => {
      if (segments.length === 0 || segments.every(segment => !isSegmentRoutable(segment))) {
        dispatch(updateRouting({ activityType: newActivity }));
        return;
      }

      const { isSuccess, data } = await rerouteSegments({ segments, newActivity });

      if (isSuccess && data) {
        dispatch(updateRouting({ activityType: newActivity, segments: data.segments }));
      }
    },
    [segments, dispatch, rerouteSegments]
  );

  return onActivityChange;
};

export default useOnActivityChange;
